// extracted by mini-css-extract-plugin
export default {"title":"Highlights_title__YcUYF"};